import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function nairaFormat(n) {
  if (n == null || isNaN(n)) return "₦0";
  return "₦" + Number(n).toLocaleString("en-NG");
}

export function calcEarnings(totalFollowers) {
  const gross = Math.round((Number(totalFollowers || 0) / 1000) * 500);
  return {
    gross,
    creative: Math.round(gross * 0.8),
    agency: Math.round(gross * 0.2),
  };
}

/** Parse a follower_range_label like "5,000 – 10,000" and return the creative-take-home range.
 * Returns null if the label isn't a range (single number or missing). */
export function parseRangeEarnings(label) {
  if (!label) return null;
  const nums = String(label).match(/[\d,]+/g);
  if (!nums || nums.length < 2) return null;
  const min = Number(nums[0].replace(/,/g, ""));
  const max = Number(nums[1].replace(/,/g, ""));
  if (!min || !max || min === max) return null;
  return {
    minCreative: calcEarnings(min).creative,
    maxCreative: calcEarnings(max).creative,
    minGross: calcEarnings(min).gross,
    maxGross: calcEarnings(max).gross,
  };
}

export function formatCreativeShare(gig) {
  // If the gig has a follower range label, show a range. Otherwise the single stored amount.
  const r = !gig.is_special ? parseRangeEarnings(gig.follower_range_label) : null;
  if (r) return `${nairaFormat(r.minCreative)} – ${nairaFormat(r.maxCreative)}`;
  return nairaFormat(gig.creative_share_ngn);
}

/** Return the effective minimum follower count that a creative must have to be eligible
 * for a gig. Source-of-truth priority:
 *   1. is_special → 0 (no minimum)
 *   2. Parse the range label the creative actually sees (e.g. "1,000 – 10,000" → 1000).
 *      This protects against admin data-entry drift where required_followers and
 *      the label were edited independently (Edit Gig form has separate fields).
 *   3. Fall back to stored required_followers.
 */
export function getGigMinReach(gig) {
  if (!gig) return 0;
  if (gig.is_special) return 0;
  const label = gig.follower_range_label;
  if (label) {
    const nums = String(label).match(/[\d,]+/g);
    if (nums && nums.length >= 1) {
      const first = Number(nums[0].replace(/,/g, ""));
      if (Number.isFinite(first) && first > 0) return first;
    }
  }
  return Number(gig.required_followers || 0);
}
